<template>
    <v-card class="pa-5">
        <v-card-text class="pa-0 text-body-1">
            {{ $t('current-subscription') }} {{ $route.params.name }}
        </v-card-text>
        <v-container class="pa-0 mt-8">
            <v-row class="ma-0 pa-0">
                <v-col cols="12" md="3" class="pa-0">
                    <v-select
                        v-model="planDuration"
                        :label="$t('subscription-duration')"
                        :items="plansDuration"
                        dense
                        outlined
                    />
                </v-col>
            </v-row>
            <v-row class="ma-0 pa-0 mt-10">
                <v-col cols="12" md="3" class="pa-0">
                    <v-select
                        v-model="planName"
                        :label="$t('subscription-name')"
                        :items="plansName"
                        dense
                        outlined
                    />
                </v-col>
            </v-row>
            <v-row class="ma-0 pa-0 mt-10">
                <v-col cols="12" md="3" class="pa-0">
                    <template>
                        <v-text-field
                            id="expireDate"
                            v-model="expireDate"
                            :label="$t('subscription-expire-date')"
                            append-icon="mdi-calendar"
                            :rules="[v => !!v || $t('is-required')]"
                            outlined
                            dense
                            clearable
                        />
                        <date-picker
                            v-model="expireDate"
                            element="expireDate"
                            :locale="$store.state.date_locale"
                            :format="$store.state.date_format"
                            auto-submit
                            :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                            @close="setDate"
                        />
                    </template>
                </v-col>
            </v-row>
            <v-row class="ma-0 pa-0 flex-column mt-10">
                <v-col
                  cols="12"
                  md="3"
                  class="pa-0 mt-5"
                >
                  <v-container class="pa-0 d-flex gap-2">
                    <v-card-text class="pa-0 text-body-2 mt-2" style="width: 150px;">{{ $t('smsCountRemain') }}</v-card-text>
                    <v-text-field
                      v-model.number="smsCount"
                      min="-1"
                      :max="1000000"
                      type="number"
                      outlined
                      hide-details
                      hide-spin-buttons
                      dense
                    />
                  </v-container>
                </v-col>
                <v-col
                    cols="12"
                    md="3"
                    class="pa-0 mt-5"
                    v-for="(option, index) in plansLimit"
                    :key="index"
                >
                    <v-container class="pa-0 d-flex gap-2">
                        <v-card-text class="pa-0 text-body-2 mt-2" style=" width: 150px;">{{ option.title }}</v-card-text>
                        <v-text-field
                          v-model.number="option.value"
                          min="-1"
                          :max="1000000"
                          type="number"
                          outlined
                          hide-details
                          hide-spin-buttons
                          :disabled="option.isOptionInfinite"
                          dense
                        />
                        <div class="d-flex gap-2 mt-1">
                          <v-checkbox
                            v-model="option.isOptionInfinite"
                            color="secondary"
                            class="ma-0 pa-0"
                            @change="onInfiniteCheckboxToggle(option)"
                          />
                          <v-card-text class="pa-0 text-body-2 mt-1">{{ $t('infinite') }}</v-card-text>
                        </div>
                    </v-container>
                </v-col>
            </v-row>
            <v-row class="ma-0 pa-0 flex-column mt-10">
                <v-col
                    cols="12"
                    md="3"
                    class="pa-0 mt-5"
                    v-for="(option, index) in plansPermission"
                    :key="index"
                >
                    <v-container class="pa-0 d-flex align-center gap-2">
                        <v-card-text class="pa-0 text-body-2">{{ option.title }}</v-card-text>
                        <v-container class="wrapper-toggle d-flex pa-0 ma-0" style="width: 150px;">
                            <div
                                v-for="(item, index) in activatorOptions"
                                :key="index"
                                @click="option.value = item.value"
                                class="child flex-fill text-center"
                                :style="{
                                    'background-color': option.value == item.value ? '#E5FEED' : '',
                                    'border-color': option.value == item.value ? '#0066ff' : 'silver',
                                    'color': option.value == item.value ? '#137333' : ''
                                }"
                            >
                                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
                            </div>
                        </v-container>
                    </v-container>
                </v-col>
            </v-row>
            <v-btn
                color="primary"
                class="mt-12"
                @click="editPlan"
                :loading="loading"
            >
            {{ $t('edit') }}
            </v-btn>
        </v-container>
        <v-snackbar
          v-model="snakbar"
          :color="(snakbarColor ? snakbarColor : 'primary')"
          top
          style="z-index: 1000000000000 !important;"
        >
          {{ snakbarText }}

          <template v-slot:action="{ attrs }">
            <v-btn
              color="white"
              text
              v-bind="attrs"
              @click="snakbar = !snakbar"
            >
              {{ $t('close') }}
            </v-btn>
          </template>
        </v-snackbar>
    </v-card>
</template>

<script>
import { mapState } from 'vuex'
import General from '../../../../Mixins/general'
import moment from 'moment-jalaali'

export default {
  mixins: [General],
  data () {
    return {
      userCurrentPlan: null,
      expireDate: null,
      plansLimit: null,
      plansPermission: null,
      planName: null,
      plansName: null,
      plansList: null,
      plansDuration: null,
      planDuration: null,
      selectedPlan: null,
      initialPlanName: null,
      smsCount: null,
      snakbar: false,
      snakbarColor: null,
      snakbarText: null,
      loading: false
    }
  },
  computed: {
    activatorOptions () {
      return [
        { label: this.$t('active'), value: 'active' },
        { label: this.$t('deactive'), value: 'deactive' }
      ]
    }
  },
  methods: {
    fetchUserCurrentPlan () {
        var app = this
        app.$axios.get(app.$endpoint + 'get-user-plan/' + `${this.$route.params.abr}`)
          .then(r => {
            this.userCurrentPlan = r.data
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
    },
    fetchPlansList () {
      var app = this
      const endpoint = 'https://plans.abriron.com/api/'
      app.$axios.get(endpoint + 'plan-duration', {
        headers: {
          'X-API-KEY': 'ZEBQXqT6fYykTWRh9zhqJCBTtXfM1MXTmjIcYHw',
          abr: this.$route.params.abr
        },
        params: {
          type: 'all'
        }
      })
        .then(r => {
          this.plansList = r.data
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => (app.loading = false))
    },
    getUserPlanDur () {
      if (this.userCurrentPlan && this.plansList && this.plansList.length > 0) {
        return this.plansList
          .map(item => item.plans) 
          .flat()
          .find(plan => plan.duration_id == this.userCurrentPlan.plan_duration_id)?.persian_month
      }
    },
    onInfiniteCheckboxToggle (option) {
      if (option.isOptionInfinite) {
        option.value = 'نامحدود'
      } else {
        option.value = 0
      }
    },
    editPlan () {
      const selectedDur = this.plansList.find(item => item.persian_month == this.planDuration).plans
      const selectedPlan = selectedDur.find(plan => plan.name == this.planName)

      var app = this
      this.loading = true
      const endpoint = 'https://plans.abriron.com/api/'
      app.$axios.post(endpoint + 'subscription/change-user-plan-option',
        {
          plan_id: selectedPlan.id,
          plan_duration_id: selectedPlan.duration_id,
          ends_at: moment(this.expireDate, 'jYYYY/jM/jD').format('YYYY-MM-DD'),
          sms_count: this.smsCount,
          plan: {
            options: [...this.plansLimit, ...this.plansPermission]
          }
        },
        {
          headers: {
            'X-API-KEY': 'ZEBQXqT6fYykTWRh9zhqJCBTtXfM1MXTmjIcYHw',
            abr: this.$route.params.abr
          }
        })
        .then(r => {
          if (r.data.status) {
            this.loading = false
            this.snakbarText = r.data.message
            this.snakbarColor = 'green'
            this.snakbar = true
            this.$router.push({ name: 'customerList' })
          }
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => (app.loading = false))
    }
  },
  mounted () {
    this.fetchPlansList()
    this.fetchUserCurrentPlan()
  },
  watch: {
    userCurrentPlan (val) {
      if (val) {
        this.expireDate = this.userCurrentPlan.ends_at
        this.plansLimit = this.userCurrentPlan.plan.options.filter(option => option.value != 'active' && option.value != 'deactive')
        this.plansPermission = this.userCurrentPlan.plan.options.filter(option => option.value == 'active' || option.value == 'deactive')
        this.planName = this.userCurrentPlan.plan.name
        this.smsCount = this.userCurrentPlan.sms_balance
        this.planDuration = this.getUserPlanDur()
        
        this.initialPlanName = this.planName
      }
    },
    plansList (val) {
      if (val) {
        this.plansDuration = val.map(item => item.persian_month)
        this.plansName = val[0].plans.map(obj => obj.name)
        this.planDuration = this.getUserPlanDur()
      }
    },
    planDuration (val) {
      this.plansName = this.plansList?.find(item => item.persian_month == val).plans.map(obj => obj.name)
    },
    planName (val) {
      if (val != this.initialPlanName) {
        this.selectedPlan = this.plansList.find(item => item.persian_month == this.planDuration).plans.find(obj => obj.name == val)

        if (this.selectedPlan) {
          this.plansLimit = this.selectedPlan.options.filter(option => option.value != 'active' && option.value != 'deactive')
          this.plansPermission = this.selectedPlan.options.filter(option => option.value == 'active' || option.value == 'deactive')
        }
      }
    },
    plansLimit (val) {
      if (val) {
        val.forEach(option => {
          if (option.value == 'نامحدود') {
            option.isOptionInfinite = true
          } else {
            option.isOptionInfinite = false 
          }
        })
      }
    }
  }
}
</script>

<style>
.wrapper-toggle {
  border: 1px solid silver;
  border-radius: 4px;
}
.wrapper-toggle .child {
  padding: 7.7px;
  cursor: pointer;
  border-radius: 4px;
}
.wrapper-toggle .child:first-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.wrapper-toggle .child:nth-child(2) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.v-application--is-rtl .v-input--selection-controls__input {
  margin-left: 0 !important;
}
</style>